import { render } from "./InhouseService.vue?vue&type=template&id=2a71ae46&scoped=true"
import script from "./InhouseService.vue?vue&type=script&lang=js"
export * from "./InhouseService.vue?vue&type=script&lang=js"

import "./InhouseService.vue?vue&type=style&index=0&id=2a71ae46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a71ae46"]])

export default __exports__